<template>
  <div>
    <div
      class="columns is-8-widescreen"
      v-for="(vehicle, index) in lienholderVehicles"
      v-bind:key="index"
    >
      <div class="column is-half" v-if="index === lienholderIndex">
        <div class="select-wrapper -spacing-static-c">
          <label
            :for="'lienHolderOptions' + index"
            :class="{
              error: errors.has('lienHolderOptions' + index)
            }"
            >Who is your lienholder?</label
          >
          <v-select
            v-model="lienHoldersData[index].option"
            :options="selects.lienHolderOptions"
            placeholder="Who is your lienholder?"
            @input="changeLienHolders(index)"
            :searchable="false"
            :name="'lienHolderOptions' + index"
            v-validate="'required'"
            :class="{
              error: errors.has('lienHolderOptions' + index),
              longOptions: true
            }"
            data-vv-validate-on="input|blur"
          ></v-select>
        </div>

        <label class="input -spacing-static-c">
          <input
            :class="{
              input__field: true,
              error: errors.has('lienHoldersName' + index)
            }"
            :name="'lienHoldersName' + index"
            type="text"
            placeholder="Lienholders Name"
            v-model="lienHoldersData[index].name"
            v-validate="'required'"
            :disabled="lienHoldersData[index].isDisabled"
          />
          <span class="input__label">Lienholders Name</span>
        </label>

        <label class="input -spacing-static-c">
          <input
            :class="{
              input__field: true,
              error: errors.has('lienHoldersAddress' + index)
            }"
            :name="'lienHoldersAddress' + index"
            type="text"
            placeholder="Address"
            v-model="lienHoldersData[index].address"
            v-validate="'required'"
            :disabled="lienHoldersData[index].isDisabled"
          />
          <span class="input__label">Address</span>
        </label>

        <label class="input -spacing-static-c">
          <input
            :class="{
              input__field: true,
              error: errors.has('lienHoldersCity' + index)
            }"
            :name="'lienHoldersCity' + index"
            type="text"
            placeholder="City"
            v-model="lienHoldersData[index].city"
            v-validate="'required'"
            :disabled="lienHoldersData[index].isDisabled"
          />
          <span class="input__label">City</span>
        </label>
        <div
          class="select-wrapper -spacing-static-c"
          v-show="lienHoldersData[index].showStateDropDown"
        >
          <label
            :for="'lienHoldersState' + index"
            :class="{
              error: errors.has('lienHoldersState' + index)
            }"
            >State</label
          >
          <v-select
            v-model="lienHoldersData[index].state"
            :searchable="false"
            placeholder="State"
            :options="selects.lienHolderStates"
            v-validate="'required'"
            :name="'lienHoldersState' + index"
            :class="{ error: errors.has('lienHoldersState' + index) }"
          ></v-select>
        </div>
        <label
          class="input -spacing-static-c"
          v-show="!lienHoldersData[index].showStateDropDown"
        >
          <input
            :class="{
              input__field: true,
              error: errors.has('lienHoldersState' + index)
            }"
            :name="'lienHoldersState' + index"
            type="text"
            placeholder="State"
            v-model="lienHoldersData[index].state.value"
            v-validate="'required'"
            :disabled="lienHoldersData[index].isDisabled"
          />
          <span class="input__label">State</span>
        </label>
        <label class="input -spacing-static-c">
          <input
            :class="{
              input__field: true,
              error: errors.has('lienHoldersZip' + index)
            }"
            :name="'lienHoldersZip' + index"
            placeholder="Zip"
            @input="onlyNumbers(index)"
            maxlength="5"
            :disabled="lienHoldersData[index].isDisabled"
            v-model="lienHoldersData[index].zip"
            v-validate="'required|numeric|length:5'"
            data-vv-validate-on="input|blur"
          />
          <span class="input__label">Zip</span>
        </label>

        <label class="input -spacing-static-c">
          <cleave
            :class="{
              input__field: true,
              error: errors.has('phoneNumber' + index)
            }"
            :name="'phoneNumber' + index"
            :options="validationOptions.phoneNumber"
            placeholder="Phone Number (000-000-0000)"
            v-model="lienHoldersData[index].phoneNumber"
            v-validate="'required|phoneNumber'"
            :disabled="lienHoldersData[index].isDisabled"
          ></cleave>
          <span class="input__label">Phone Number (000-000-0000)</span>
        </label>
      </div>
      <div
        class="column is-half has-columns-above right-section"
        v-if="index === lienholderIndex"
      >
        <div class="box -spacing-static-e">
          <div>
            <h3 class="heading right-section-first-container">Vehicle</h3>
            <div class="columns is-mobile">
              <div class="column is-4">Model:</div>
              <div class="column is-8">
                {{
                  vehicle.year +
                    ' ' +
                    vehicle.make +
                    ' ' +
                    vehicle.model +
                    ' ' +
                    vehicle.style
                }}
              </div>
            </div>
            <div class="columns is-mobile">
              <div class="column is-4">VIN:</div>
              <div class="column is-8">{{ vehicle.vin }}</div>
            </div>
            <div class="columns is-mobile vehicle-image-container">
              <div
                class="column is-12"
                v-if="
                  vehicleImageResponse &&
                    vehicleImageResponse.Vin &&
                    vehicleImageResponse.Vin.picture
                "
              >
                <img
                  :src="getVehicleImageFromResponse(vehicleImageResponse)"
                  v-bind:alt="'car'"
                />
              </div>
              <div v-else class="column is-12">
                <img
                  :src="
                    vehicleImgBaseUrl +
                      'images-api/v1/ffddfa3eb8056090b9dd6602d1c910a7/5'
                  "
                  alt="default"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-right-align">
      <button
        @click="backButtonNavigation"
        type="button"
        v-if="lienholderIndex > 0"
        class="button-primary button-primary--black -spacing-static-b back-button"
      >
        <span class="button-primary__icon icon icon--arrow-right-hair">
          <span class="loader-base button-primary__loader"></span>
        </span>
        <span class="button-primary__label">Back</span>
      </button>
      <button
        @click="submitForFinal()"
        type="button"
        class="button-primary button-primary--black -spacing-static-b"
        v-if="lienholderIndex === lienholderVehicles.length - 1"
      >
        <span class="button-primary__icon icon icon--arrow-right-hair">
          <span class="loader-base button-primary__loader"></span>
        </span>
        <span class="button-primary__label">Submit</span>
      </button>
      <button
        @click="continueNavigation()"
        type="button"
        class="button-primary button-primary--black -spacing-static-b lienholder-continue-button"
        v-else
      >
        <span class="button-primary__icon icon icon--arrow-right-hair">
          <span class="loader-base button-primary__loader"></span>
        </span>
        <span class="button-primary__label">Continue</span>
      </button>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
export default {
  props: ['lienHoldersData', 'selects', 'lienholderVehicles'],
  name: 'Lienholders',
  data: () => ({
    lienholderIndex: 0,
    validationOptions: {
      phoneNumber: {
        phone: true,
        phoneRegionCode: 'US',
        delimiter: '-'
      }
    },
    vehicleImgBaseUrl: process.env.VUE_APP_PORSCHE_PIC_BASE_URL
  }),
  methods: {
    ...mapMutations(['updateForm', 'updateVehicleImageResponse']),
    ...mapActions(['requestQuote', 'getVehicleImage']),
    submitForFinal() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit('sendDataBack');
        } else {
          let firstErrorField = this.$el.querySelector(
            '[name="' + this.$validator.errors.items[0].field + '"]'
          );
          if (firstErrorField) {
            firstErrorField.focus();
          }
        }
      });
    },

    changeLienHolders(data) {
      const selectedOptionFromDropDown = this.lienHoldersData[data].option
        .value;
      if (selectedOptionFromDropDown === "I don't know") {
        this.lienHoldersData[data].zip = '';
        this.lienHoldersData[data].state = {
          label: null,
          value: null
        };
        this.lienHoldersData[data].city = '';
        this.lienHoldersData[data].address = '';
        this.lienHoldersData[data].name = '';
        this.lienHoldersData[data].phoneNumber = '';
        this.lienHoldersData[data].skipSend = true;
        this.lienHoldersData[data].isDisabled = true;
        this.lienHoldersData[data].showStateDropDown = false;
        setTimeout(() => {
          this.errors.clear();
        }, 25);
      } else if (selectedOptionFromDropDown === 'PFS') {
        this.lienHoldersData[data].zip = '30354';
        this.lienHoldersData[data].state = {
          label: 'Georgia',
          value: 'GA'
        };
        this.lienHoldersData[data].city = 'Atlanta';
        this.lienHoldersData[data].address = 'One Porsche Drive';
        this.lienHoldersData[data].name = 'Porsche';
        this.lienHoldersData[data].phoneNumber = '18007677243';
        this.lienHoldersData[data].skipSend = false;
        this.lienHoldersData[data].isDisabled = true;
        this.lienHoldersData[data].showStateDropDown = false;
        setTimeout(() => {
          this.errors.clear();
        }, 50);
      } else if (selectedOptionFromDropDown === 'PLL') {
        this.lienHoldersData[data].zip = '30354';
        this.lienHoldersData[data].state = {
          label: 'Georgia',
          value: 'GA'
        };
        this.lienHoldersData[data].city = 'Atlanta';
        this.lienHoldersData[data].address = 'One Porsche Drive';
        this.lienHoldersData[data].name = 'Porsche';
        this.lienHoldersData[data].phoneNumber = '18007677243';
        this.lienHoldersData[data].skipSend = false;
        this.lienHoldersData[data].isDisabled = true;
        this.lienHoldersData[data].showStateDropDown = false;
        setTimeout(() => {
          this.errors.clear();
        }, 50);
      } else {
        this.lienHoldersData[data].zip = '';
        this.lienHoldersData[data].state = {
          label: null,
          value: null
        };
        this.lienHoldersData[data].city = '';
        this.lienHoldersData[data].address = '';
        this.lienHoldersData[data].name = '';
        this.lienHoldersData[data].phoneNumber = '';
        this.lienHoldersData[data].skipSend = false;
        this.lienHoldersData[data].isDisabled = false;
        this.lienHoldersData[data].showStateDropDown = true;
        setTimeout(() => {
          this.errors.clear();
        }, 50);
      }
    },

    onlyNumbers(index) {
      this.lienHoldersData[index].zip = this.lienHoldersData[index].zip
        .toString()
        .replace(/[^0-9]/g, '');
    },

    getVehicleImageFromResponse(response) {
      if (
        response &&
        response.Vin &&
        response.Vin.picture &&
        response.Vin.picture
      ) {
        let vehicleImg = response.Vin.picture.filter(img => {
          return img._attributes.view === 'extcam02';
        });
        if (vehicleImg && vehicleImg.length) {
          return vehicleImg[0]._attributes.uri;
        } else if (response.Vin.picture[0]) {
          return response.Vin.picture[0]._attributes.uri;
        }
      }
    },
    fetchVehicleImage() {
      this.getVehicleImage({
        vin: this.lienholderVehicles[this.lienholderIndex].vin,
        year: this.lienholderVehicles[this.lienholderIndex].year,
        model: this.lienholderVehicles[this.lienholderIndex].model
      });
    },
    backButtonNavigation() {
      this.lienholderIndex--;
      this.fetchVehicleImage();
    },
    continueNavigation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.lienholderIndex++;
          this.fetchVehicleImage();
        } else {
          let firstErrorField = this.$el.querySelector(
            '[name="' + this.$validator.errors.items[0].field + '"]'
          );
          if (firstErrorField) {
            firstErrorField.focus();
          }
        }
      });
    }
  },
  beforeMount() {
    this.fetchVehicleImage();
  },
  computed: {
    ...mapGetters(['vehicleImageResponse'])
  }
};
</script>
<style scoped lang="scss">
.box {
  padding: 1rem;

  @media (min-width: 1000px) {
    padding: 2rem;
  }

  @media (min-width: 1400px) {
    padding: 1rem 3rem;
    padding-bottom: 3.5rem;
  }
}
.total-cost-container {
  @media (min-width: 1000px) {
    margin-top: 4rem;
  }
}

.heading,
.estimated-cost {
  font-family: $family-sans-serif-bold;
  text-transform: none;
  letter-spacing: 0;
  font-size: inherit;
}

.heading {
  margin-bottom: 1rem;

  &:last-of-type {
    border-top: 1px solid $mischka;
    margin-top: 2rem;
    padding-top: 2rem;
  }
}

.right-section-first-container {
  border-top: none !important;
  margin-top: 0 !important;
}

.note {
  color: $mischka;
}

.input__field:disabled {
  color: #737278;
}

.effective-date-field {
  margin-top: 2.5rem;
}

.disabled {
  background-color: #b5b4ba;
}
.disabled__button__color {
  color: #ffffff !important;
}
button {
  border: none;
}
.right-section {
  margin-top: 0.6rem;
}
</style>
